import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { Package, BookOpen, TShirt, Gift, Article } from "@phosphor-icons/react";
import { toast } from "sonner";

const TYPES = ["Books", "Colouring books", "Clothing", "Plush toys", "Posters", "School products", "Digital products"];
const ICON = { "Colouring book": BookOpen, "Plush toy": Gift, "School product": Article };

export default function Merch() {
  const { data: merch, loading } = useFetch("/merch");
  const { data: chars } = useFetch("/characters");
  if (loading || !merch) return <Loading />;

  return (
    <div>
      <PageHeader icon={Package} title="Merchandise Studio"
        subtitle="Future-ready product concepts. Reuse official character assets for approved product ideas across books, toys, clothing and more." />

      <div className="mb-6 flex flex-wrap gap-2">
        {TYPES.map((t) => <Tag key={t}>{t}</Tag>)}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {merch.map((m) => {
          const Icon = ICON[m.type] || TShirt;
          const ch = chars?.find((c) => c.name === m.character);
          return (
            <Panel key={m.id} data-testid={`merch-${m.id}`} hover>
              <div className="aspect-square rounded-xl bg-black/30 border border-white/8 mb-4 flex items-center justify-center overflow-hidden relative">
                {ch && <img src={ch.image} alt="" className="h-24 w-24 rounded-xl object-cover opacity-80" />}
                <Icon size={22} weight="duotone" className="text-[#00E5FF] absolute bottom-3 right-3" />
              </div>
              <div className="font-medium text-white">{m.name}</div>
              <div className="text-xs text-zinc-500 mt-0.5">{m.type} · {m.character}</div>
              <div className="mt-3 flex items-center justify-between">
                <Tag>{m.status}</Tag>
                <button onClick={() => toast("Phase 2: generate a product mockup with AI.")} className="text-xs text-[#00E5FF] hover:underline">Generate mockup</button>
              </div>
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
